// Glowkeep hero: the pre-rendered Blender clip (orb on a real fir, orbiting camera) in a <video>,
// plus the bits around it: autoplay nudge, sound toggle, snow, order-cut-off countdown.
// The three.js tree that used to live here was replaced on 2026-10-16 (see blender/hero.py).
export function initHeroUI(root){
  const v = root.querySelector('[data-ref="video"]');
  const stage = root.querySelector('[data-ref="stage"]');
  const btn = root.querySelector('[data-ref="sound"]');
  if (v){
    v.muted = true; const go = () => { const p = v.play(); if (p && p.catch) p.catch(() => {}); }; go();
    document.addEventListener('pointerdown', go, { once: true });
    if (stage) stage.addEventListener('click', e => { if (e.target !== btn) go(); });
    if (btn){
      // One file carries the audio track (autoplay works because it starts muted); an optional second
      // URL with sound is still supported for stores that keep a silent copy.
      let swapped = false; const soundSrc = btn.dataset.soundSrc;
      btn.addEventListener('click', () => {
        if (!swapped && soundSrc && soundSrc !== v.currentSrc && soundSrc !== v.getAttribute('src')){
          const t = v.currentTime || 0; swapped = true;
          v.src = soundSrc; v.muted = false; v.volume = 1;
          v.addEventListener('loadedmetadata', () => { try { v.currentTime = t; } catch(e){} }, { once: true });
          go();
        } else { v.muted = !v.muted; v.volume = 1; go(); }
        const on = !v.muted;
        btn.setAttribute('aria-pressed', on); btn.textContent = on ? '♪ Sound on' : '♪ Tap for sound';
      });
    }
  }
  const snow = root.querySelector('[data-ref="snow"]');
  if (snow && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    const ctx = snow.getContext('2d'); let w = 0, h = 0; const flakes = [];
    const size = () => { const r = snow.getBoundingClientRect(); w = snow.width = r.width; h = snow.height = r.height; };
    size(); new ResizeObserver(size).observe(snow);
    for (let i = 0; i < 70; i++) flakes.push({ x: Math.random(), y: Math.random(), r: .6 + Math.random() * 2, s: .15 + Math.random() * .5, d: Math.random() * 6 });
    (function tick(t){ ctx.clearRect(0, 0, w, h); ctx.fillStyle = 'rgba(255,255,255,.75)';
      for (const f of flakes){ f.y += f.s / h * 1.6; if (f.y > 1.02){ f.y = -.02; f.x = Math.random(); } const x = f.x * w + Math.sin(t * .0006 + f.d) * 8; ctx.beginPath(); ctx.arc(x, f.y * h, f.r, 0, 6.283); ctx.fill(); }
      requestAnimationFrame(tick); })(0);
  }
  const days = root.querySelector('[data-ref="days"]');
  if (days && days.dataset.cutoff){
    const d = new Date(days.dataset.cutoff + 'T23:59:00+11:00');
    days.textContent = Math.max(0, Math.ceil((d - new Date()) / 86400000));
  }
}

document.querySelectorAll('[data-gk-hero]').forEach(root => { try { initHeroUI(root); } catch(e){ console.warn('Glowkeep hero', e); } });
